import * as React from "react";
import { withTranslation } from "react-i18next";
import { ComponentEx } from "../../../controls/ComponentEx";
class DefaultInfoPanel extends ComponentEx {
    constructor(props) {
        super(props);
        this.initState({});
    }
    render() {
        const { t, infoText } = this.props;
        return (React.createElement("div", { id: "loadorderinfo" },
            React.createElement("h2", null, t("Changing your load order")),
            React.createElement("p", null, infoText)));
    }
}
export default withTranslation(["common"])(DefaultInfoPanel);
